export class SocialSigninModel {
  constructor() {
    this.email = "";
    this.token = "";
    this.platform = "";
  }
}
